const firebase = require("firebase");

require("firebase/firestore");

firebase.initializeApp({
  apiKey: "AIzaSyBHz60EWkS_ZTljIfSic5wQMZsH613VzOo",
  authDomain: "jacktan-239f7.firebaseapp.com",
  projectId: "jacktan-239f7",
});

const db = firebase.firestore();

export default db;
